import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../../pages/staffing-page/d-sickness-absence-statistics';
import type { SickLeaveSummaryData } from '../summary-view';

/**
 * Sick leave summary component (Sykefraværsstatistikk)
 * Wraps d-sickness-absence-statistics from staffing page
 */
@customElement('d-sick-leave-summary')
export class DSickLeaveSummary extends LitElement {
  @property({ type: Object })
  data!: SickLeaveSummaryData;

  render() {
    return html`
      <d-sickness-absence-statistics
        hide-header
        opened
        .sicknessAbsenceStats=${this.data.sicknessAbsenceStats}
        .employees=${this.data.employees}
      >
      </d-sickness-absence-statistics>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-sick-leave-summary': DSickLeaveSummary;
  }
}
